import React from 'react';
import PropTypes from 'prop-types';
import css from './SelectionInformation.scss';

export default class SelectionInformation extends React.Component {

  render() {
    return <div className={css['selected-info']}>
      <b>Selected</b>: {this.props.totalSelected}
    </div>
  }

}

SelectionInformation.propTypes = {
  totalSelected: PropTypes.number.isRequired
};

